module.exports = __webpack_public_path__ + "img/bg3.2445dfe0.jpg";